export default `float fogDist = length(vWorldPos - cameraPosition);
float fogHoriz = max(fogDist - uFogStart, 0.0);
float fogFactor = 1.0 - exp(-uFogDensity * uFogDensity * fogHoriz * fogHoriz);
float heightFog = exp(-uFogHeightFalloff * max(vWorldPos.y, 0.0));
fogFactor = clamp(fogFactor * mix(0.35, 1.0, heightFog), 0.0, 1.0);
float stormDist = length(vWorldPos - uStormOrigin);
float stormFog = 1.0 - exp(-uStormDensity * uStormDensity * stormDist * stormDist);

stormFog = mix(stormFog, 1.0, smoothstep(0.8, 0.95, stormFog));
fogFactor = 1.0 - (1.0 - fogFactor) * (1.0 - stormFog);
vec3 viewDir = (vWorldPos - cameraPosition) * inversesqrt(max(dot(vWorldPos - cameraPosition, vWorldPos - cameraPosition), 1e-6));
float sun = pow(clamp(dot(viewDir, uSunDir), 0.0, 1.0), 6.0);
vec3 fogCol = mix(uFogColor, vec3(1.0, 0.78, 0.55), sun * uSunScatter * fogFactor);
gl_FragColor.rgb = mix(gl_FragColor.rgb, fogCol, fogFactor);`